export default function QuestionCardSkeleton() {
  return (
    <div className="bg-white rounded-lg shadow-sm border p-4 flex-shrink-0 min-w-[280px] animate-pulse">
      {/* Question skeleton */}
      <div className="mb-4">
        <div className="h-5 bg-gray-200 rounded w-full mb-2"></div>
        <div className="h-5 bg-gray-200 rounded w-3/4"></div>
      </div>

      {/* Options skeleton */}
      <div className="space-y-3 mb-4">
        <div className="flex items-center p-3 border rounded-lg">
          <div className="w-4 h-4 bg-gray-200 rounded-full mr-3"></div>
          <div className="h-4 bg-gray-200 rounded w-2/3"></div>
        </div>
        <div className="flex items-center p-3 border rounded-lg">
          <div className="w-4 h-4 bg-gray-200 rounded-full mr-3"></div>
          <div className="h-4 bg-gray-200 rounded w-1/2"></div>
        </div>
        <div className="flex items-center p-3 border rounded-lg">
          <div className="w-4 h-4 bg-gray-200 rounded-full mr-3"></div>
          <div className="h-4 bg-gray-200 rounded w-3/4"></div>
        </div>
      </div>

      {/* Stats skeleton */}
      <div className="flex justify-between text-sm">
        <div className="h-4 bg-gray-200 rounded w-16"></div>
        <div className="h-4 bg-gray-200 rounded w-20"></div>
      </div>
    </div>
  );
}
